import LocalStorageService from '../../../services/local-storage-service';
import useMobileDevice from '../../../hooks/use-mobile-device';
import {
  GET_COMMENT_LIST_DATA, GET_COMMENT_LIST_DATA_SUCCESS, GET_NOTIFICATION_LIST_DATA, GET_NOTIFICATION_LIST_DATA_SUCCESS,
  TOGGLE_RIGHT_DRAWER, TOGGLE_RIGHT_DRAWER_TAB, TOGGLE_RIGHT_DRAWER_FIRST_TAB,
} from '../../../constants/system/actions';

const rightDrawerReducer: Reducer = (
  state: ReducerState = {
    isDrawerOpen: false,
    isFirstTabOpen: true,
    isLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  let isRightDrawerOpen: boolean;
  let isTabChanged: boolean;

  const isMobileDevice: boolean = useMobileDevice();

  state.isDrawerOpen = LocalStorageService.hasFixedRightDrawerValue()
    ? LocalStorageService.getFixedRightDrawerValue() : !isMobileDevice;

  switch (action.type) {
    case TOGGLE_RIGHT_DRAWER:
      isRightDrawerOpen = !state.isDrawerOpen;

      LocalStorageService.setFixedRightDrawer(isRightDrawerOpen);

      return {
        ...state,
        isDrawerOpen: isRightDrawerOpen,
      };
    case TOGGLE_RIGHT_DRAWER_TAB:
      isTabChanged = action.payload !== state.isFirstTabOpen;
      isRightDrawerOpen = isTabChanged && state.isDrawerOpen
        ? state.isDrawerOpen : !state.isDrawerOpen;

      LocalStorageService.setFixedRightDrawer(isRightDrawerOpen);

      return {
        ...state,
        isFirstTabOpen: action.payload,
        isDrawerOpen: isRightDrawerOpen,
      };
    case TOGGLE_RIGHT_DRAWER_FIRST_TAB:
      return {
        ...state,
        isFirstTabOpen: action.payload,
      };
    case GET_COMMENT_LIST_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case GET_COMMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case GET_NOTIFICATION_LIST_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case GET_NOTIFICATION_LIST_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default rightDrawerReducer;
